module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a4-4-e93e4b05629fa974b7657a040ab1d831.jpg";